import { Buffer } from 'buffer';
export function filterPrices(prices) {
    const now = new Date();
    return prices.map(p => {
        return {
            from: Buffer.from(p.f, 'base64').toString(),
            to: Buffer.from(p.t, 'base64').toString(),
            weekPrice: Buffer.from(p.wp, 'base64').toString()
        };
    }).filter(p => getDate(p.to) > now);
}
export function getDate(date) {
    const parts = date.split('.');
    return new Date(parseInt(parts[2]), Math.max(parseInt(parts[1]) - 1, 0), parseInt(parts[0]));
}
export function encodeBase64(value) {
    return Buffer.from(value).toString('base64');
}
